import React from 'react';
import { IProps } from 'components/Card/CardGrid/types';
import commonService from 'utils/commonService';

const CardGrid: React.FC<IProps> = (props) => (
  <div className="card-grid" onClick={props.onClick}>
    <div className="card-grid__cover-photo" style={{ backgroundImage: `url(${props.imgUrl})` }} />
    <div className="card-grid__title">{props.title}</div>
    <div className="card-grid__period">更新日期：{props.period}</div>
    <div className="card-grid__desc">
      <p>{commonService.htmlParser(props.desc)}</p>
    </div>
  </div>
);

export default CardGrid;
